import {
  EXPLICIT_UNKNOWN_SOURCE_DISPLAY,
  PROPERTY_GRID_SUBJECT_PROPERTY,
  schSourceType,
} from '@aloft/toolkit-shared';

import { useWatch } from 'react-hook-form';

import { PropertyGridFieldProps } from '../types.ts';
import { resolveFieldName } from '../utils.tsx';

type UsePropertyFieldProps = Pick<PropertyGridFieldProps, 'columnIndex' | 'control' | 'getValues'> &
  Required<Pick<PropertyGridFieldProps, 'isArv'>> & {
    field: Pick<PropertyGridFieldProps['field'], 'fieldName' | 'toDisplayValue' | 'toTriggerLabel'>;
  };

export const usePropertyField = ({
  columnIndex,
  control,
  getValues,
  isArv,
  field,
}: UsePropertyFieldProps) => {
  const { fieldName: rawFieldName, toDisplayValue, toTriggerLabel } = field;

  const propertyId = getValues(`columns.${columnIndex}.propertyId`);
  const isSubject = propertyId === PROPERTY_GRID_SUBJECT_PROPERTY;

  const { fieldName, propertyDataFieldName, selectedSourceFieldName } = resolveFieldName(
    rawFieldName,
    columnIndex,
    isSubject,
    isArv,
  );

  const value = useWatch({ control, name: propertyDataFieldName }) as string | undefined;
  const selectedSourceLeaf = useWatch({ control, name: selectedSourceFieldName }) as
    | { source?: string }
    | undefined;

  let displayValue = toDisplayValue ? toDisplayValue(value, propertyId, { isArv }) : value;
  if (selectedSourceLeaf?.source === schSourceType.enum.unknown) {
    displayValue = EXPLICIT_UNKNOWN_SOURCE_DISPLAY as typeof displayValue;
  }

  const triggerLabel = toTriggerLabel ? toTriggerLabel(value, propertyId) : undefined;

  return {
    propertyId,
    isSubject,
    fieldName,
    propertyDataFieldName,
    selectedSourceFieldName,
    value,
    displayValue,
    triggerLabel,
  };
};
